import { render } from "./qxc-hew.vue?vue&type=template&id=028079f6&scoped=true"
import script from "./qxc-hew.vue?vue&type=script&lang=js"
export * from "./qxc-hew.vue?vue&type=script&lang=js"

import "./qxc-hew.vue?vue&type=style&index=0&id=028079f6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028079f6"]])

export default __exports__